import {kebabCase, truish} from 'tizra'
import {KebabCase} from 'type-fest'

export const dataProps = <P extends object>(props: P) =>
  Object.fromEntries(
    Object.entries(props)
      .filter(([_k, v]) => truish(v))
      .map(([k, v]) => [`data-${kebabCase(k)}`, v]),
  ) as {
    [K in keyof P as K extends string ? `data-${KebabCase<K>}` : K]: P[K]
  }

export * from './breakpoints'
export * from './constants'
export * from './theme'
export * from './typography'
export * from './vars'
